













































































































































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { BrandAssetWrite, Category } from '../../common/types';
import categoryModule from '../../store/modules/category.module';
import tagModule from '../../store/modules/tag.module';
import brandModule from '../../store/modules/brand.module';
import { ASSET_URL } from '../../common/config';
import errorModule from '../../store/modules/error.module';
import { eventBus } from '../../main';
import { ASSET_CREATED, SHOW_SNACKBAR } from '../../common/constants';
import Tag from '../../common/model/Tag';
import AdminCreateTag from './AdminCreateTag.vue';

const placeholderAsset: BrandAssetWrite = {
  title: '',
  description: '',
  tags: [],
  category: '',
  img: require('@/assets/admin/placeholder.jpg'),
  brand_id: '',
  is_archived: false,
  featured: false,
  production_file_url: '',
};

@Component({
  components: {
    AdminCreateTag,
  },
})
export default class AdminBrandAssetCard extends Vue {
  @Prop() asset: any;

  @Prop({ default: false }) isCreateAssetCard: boolean;

  @Prop({ default: false }) isExpanded: boolean;

  localAsset = { ...placeholderAsset };

  cdnUrl = ASSET_URL;

  assetFile: File | null = null;

  brandModule = brandModule;

  placeholderImg = require('@/assets/admin/placeholder.jpg');

  get availableTags(): Array<Tag> {
    const tags = [...tagModule.tags];
    return tags.sort((a, b) => {
      const textA = a.title.toUpperCase();
      const textB = b.title.toUpperCase();
      if (textA < textB) {
        return -1;
      }
      if (textA > textB) {
        return 1;
      }
      return 0;
    });
  }

  get lastUpdatedDate(): string {
    if (!this.asset.created_on || this.isCreateAssetCard) { return ''; }
    const date = new Date(this.asset.created_on);
    return `Last Updated: ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

  get imageSrc(): string {
    if (this.asset.webp_url) {
      // Asset is an image, return the compressed image.
      return `${this.cdnUrl}${this.asset.webp_url}`;
    }
    // If there is no full_size_url, nothing is set
    if (!this.asset.full_size_url) {
      return this.placeholderImg;
    }
    return '';
  }

  get fileType(): string {
    const fileName: string = this.asset.full_size_url;
    const dotIndex = fileName.indexOf('.');
    const fileType = fileName.substring(dotIndex + 1).toUpperCase();
    if (fileType.length > 5) {
      return 'Processing File';
    }
    return fileType;
  }

  get availableCategories(): Array<Category> {
    const categories = [...categoryModule.categories];
    return categories.sort((a, b) => {
      const textA = a.title.toUpperCase();
      const textB = b.title.toUpperCase();
      if (textA < textB) {
        return -1;
      }
      if (textA > textB) {
        return 1;
      }
      return 0;
    });
  }

  mounted(): void {
    if (this.isCreateAssetCard) { return; }
    this.localAsset = this.asset;
  }

  async deleteAsset(): Promise<void> {
    // Cannot delete an asset that isn't created yet
    if (this.isCreateAssetCard || !this.asset.id) { return; }
    await brandModule.deleteBrandAsset(this.asset.id);
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(SHOW_SNACKBAR, 'Asset successfully deleted.')
  }

  async archiveAsset(): Promise<void> {
    this.localAsset.is_archived = !this.asset.is_archived;
    await brandModule.updateBrandAsset({ asset: this.localAsset });
    errorModule.clearError();
  }

  async updateAsset(): Promise<void> {
    if (!brandModule.brand) {
      return;
    }
    if (!this.localAsset.title) {
      eventBus.$emit(SHOW_SNACKBAR, 'Assets must include a title.')
      return;
    }

    this.localAsset.brand_id = brandModule.brand.id;
    if (this.assetFile) {
      this.localAsset.img = this.assetFile.name;
    }
    eventBus.$emit(ASSET_CREATED);

    await brandModule.updateBrandAsset({
      asset: this.localAsset,
      assetFile: this.assetFile,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(SHOW_SNACKBAR, 'Asset successfully updated.');
  }

  async createAsset(): Promise<void> {
    if (!brandModule.brand || !this.assetFile) {
      return;
    }
    if (!this.localAsset.category) {
      eventBus.$emit(SHOW_SNACKBAR, 'Please choose a category for the asset.')
      return;
    }
    if (!this.localAsset.title) {
      eventBus.$emit(SHOW_SNACKBAR, 'Assets must include a title.')
      return;
    }

    eventBus.$emit(ASSET_CREATED);

    this.localAsset.brand_id = brandModule.brand.id;
    this.localAsset.img = this.assetFile.name;
    await brandModule.createBrandAsset({
      asset: this.localAsset,
      assetFile: this.assetFile,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.localAsset = { ...placeholderAsset };
    this.assetFile = null;
    eventBus.$emit(SHOW_SNACKBAR, 'Asset successfully created.');
  }

  downloadImage(): void {
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `${ASSET_URL}${this.asset.full_size_url}`;
    a.click();
  }
}
